import { LocalStorage } from 'common/Storage';
import { LOCAL_STORAGE_KEYS } from 'constants/storage';

export const setRefreshToken = (token: string) => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, token);
};

export const getRefreshToken = () => {
  return LocalStorage.get(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
};

export const deleteRefreshToken = () => {
  LocalStorage.remove(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
};

export const getAuthHeader = (accessToken: string) => {
  return `Bearer ${accessToken}`;
};

export const getAccessTokenFromAuthHeader = (header?: string) => {
  if (!header) return '';

  return header.split(' ')[1];
};
